import React from 'react';
import UnprocessableEntity from '../../../components/Errors/UnprocessableEntity';

const UnprocessableEntityPage = () => {
  return <UnprocessableEntity />;
};

export default UnprocessableEntityPage;
